let u = {
    token_key: 'fenchuan_user_info',//缓存token的key  is_token
    isMobile: () => {//是否是移动端
        const screenWidth = window.screen.width;
        let  ua  = navigator.userAgent || navigator.vendor || navigator.opera
        console.log('screenWidth',screenWidth)
        ua = ua.toLowerCase()
        if (/HarmonyOS/i.test(ua) || screenWidth < 768){
            return true
        }
        if(/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(ua)){
            return true
        }

        // const ua = navigator.userAgent.toLowerCase();
        // const t1 = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
        //     ua
        // );
        // const t2 = !ua.match("iphone") && navigator.maxTouchPoints > 1;
        // return t1 || t2;
        return false;
    }
};


export default u;